module.exports = __webpack_public_path__ + "desserts.png?e4295b06fead5cf15d49374bcec7d91f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/upload_images/offers/desserts.png
// module id = 105
// module chunks = 13